import { render, staticRenderFns } from "./QuarterlyTable.vue?vue&type=template&id=2b43f902&scoped=true"
import script from "./QuarterlyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./QuarterlyTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuarterlyTable.vue?vue&type=style&index=0&id=2b43f902&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b43f902",
  null
  
)

export default component.exports